import React from 'react';

import Tooltip from 'components/Tooltip';

import Timer from './Timer';

/**
 * The question timer component.
 * In the sample mode, display the tooltip alongwith the title.
 *
 * @param {*} { sample, estimatedTime, onTimeout, onTick }
 * @returns
 */
const TimerWithTip = React.memo(
  ({ quizId, sample, questionEndTime, onTimeout, estimatedTime, onTick, currentTime }) => {
    const timerWithConditionalTip = sample ? (
      <Tooltip
        visible
        placement="bottom"
        style={{ maxWidth: 316, textAlign: 'left' }}
        data={() => (
          <>
            Each question has an allotted time, if the timer runs out you’ll be automatically moved to the next
            question.
          </>
        )}
      >
        {() => (
          <Timer
            currentTime={currentTime}
            time={estimatedTime}
            questionEndTime={questionEndTime}
            onTimeout={onTimeout}
            onChange={onTick}
            quizId={quizId}
          />
        )}
      </Tooltip>
    ) : (
      <Timer
        currentTime={currentTime}
        time={estimatedTime}
        questionEndTime={questionEndTime}
        onTimeout={onTimeout}
        onChange={onTick}
        quizId={quizId}
      />
    );

    return <div style={{ display: 'inline-block' }}>{timerWithConditionalTip}</div>;
  }
);

export default TimerWithTip;
